import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import ConversationWrapper from './components/ConversationWrapper'
import Drafts from '../Drafts'
import PromptPage from '../Tasks/PromptPage'
import Search from '../Search'
import './styles/main.css'
import './styles/newUI.css'

const Chat = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route index element={<ConversationWrapper />} />
                {/* The standalone All-Tasks page was merged into the landing's
                    Task Library. Redirect any deep links to the library anchor. */}
                <Route
                  path='tasks'
                  element={
                    <Navigate
                      to={{ pathname: "..", hash: "#task-library" }}
                      replace
                      relative="path"
                    />
                  }
                />
                <Route path='drafts' element={<Drafts />} />
                <Route path='tasks/new' element={<PromptPage />} />
                <Route path='tasks/:id/edit' element={<PromptPage />} />
                <Route path='search' element={<Search />} />
                <Route path=':id' element={<ConversationWrapper />} />
            </Route>
        </Routes>
    )
}

export default Chat
